export const API_URL = 'https://api.crm.digitaltriumph.co.in/api/v1/';
export const file_URL = 'https://api.crm.digitaltriumph.co.in/';
// export const API_URL = 'https://api.crm.indiafloats.in/api/v1/';
// export const file_URL = 'https://api.crm.indiafloats.in/';
